import { BillingPaymentMethod } from "@/Common/Models/UI/BillingPaymentMethod";

class BillingPaymentMethodsHelper {
    public static getPaymentMethodsDictionnary(): { [key in BillingPaymentMethod]: string } {
        return {
            [BillingPaymentMethod.Cash]: cacheStore.GetString("CashLabel"),
            [BillingPaymentMethod.DebitCard]: cacheStore.GetString("DebitCardLabel"),
            [BillingPaymentMethod.Visa]: cacheStore.GetString("VisaLabel"),
            [BillingPaymentMethod.Check]: cacheStore.GetString("CheckLabel"),
            [BillingPaymentMethod.AmericanExpress]: cacheStore.GetString("AmericanExpressLabel"),
            [BillingPaymentMethod.MasterCard]: cacheStore.GetString("MasterCardLabel"),
            [BillingPaymentMethod.OnlinePayment]: cacheStore.GetString("OnlinePaymentLabel"),
            [BillingPaymentMethod.Payable]: cacheStore.GetString("PayableLabel"),
            [BillingPaymentMethod.Receivable]: cacheStore.GetString("ReceivableLabel"),
            [BillingPaymentMethod.ElectronicFunds]: cacheStore.GetString("ElectronicFundsTransferLabel"),
            [BillingPaymentMethod.Other]: cacheStore.GetString("OtherLabel")
        };
    }

    public static getPaymentMethodsDictionnaryWithoutPayableAndReceivable(): { [key in BillingPaymentMethod]: string } {
        const paymentMethods = BillingPaymentMethodsHelper.getPaymentMethodsDictionnary();
        delete paymentMethods[BillingPaymentMethod.Payable];
        delete paymentMethods[BillingPaymentMethod.Receivable];
        return paymentMethods;
    }

    public static getPaymentMethodsDictionnaryWithoutReceivable(): { [key in BillingPaymentMethod]: string } {
        const paymentMethods = BillingPaymentMethodsHelper.getPaymentMethodsDictionnary();
        delete paymentMethods[BillingPaymentMethod.Receivable];
        return paymentMethods;
    }

    public static getPaymentMethodLabelWithId(id: BillingPaymentMethod): string {
        return BillingPaymentMethodsHelper.getPaymentMethodsDictionnary()[id] ?? null;
    }

    public static getPaymentMethodIdWithValue(value: string): BillingPaymentMethod {
        const paymentMethods = BillingPaymentMethodsHelper.getPaymentMethodsDictionnary();

        for (const key in paymentMethods) {
            if (paymentMethods.hasOwnProperty(key) && paymentMethods[key] === value) {
                return Number(key) as BillingPaymentMethod;
            }
        }

        return undefined;
    }
}

export { BillingPaymentMethodsHelper };
